module.exports = __webpack_public_path__ + "static/media/mongo.d324ee17.png";